import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import AccessibilityMenu from './components/accessibility/AccessibilityMenu'
import CookieConsentBanner from './components/common/CookieConsentBanner'
import InstallAppBanner from './components/common/InstallAppBanner'
import './styles/index.css'

// Create a query client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

// NOTE: pinch-zoom is intentionally NOT blocked. Disabling zoom violates
// WCAG 2.1 SC 1.4.4 (Resize Text) / ת"י 5568 and exposes us to accessibility
// litigation under חוק שוויון זכויות לאנשים עם מוגבלות. Users must be able to zoom.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <AccessibilityMenu />
        <CookieConsentBanner />
        <InstallAppBanner />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)

// Register the service worker — this is what makes the app installable to the
// home screen. It caches nothing personal (see public/sw.js); failures are
// non-fatal, the app works exactly the same without it.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('[pwa] service worker registration failed', error)
    })
  })
}
